import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NavbarComp from '../components/NavbarComp';
import FooterComp from '../components/FooterComp';
import { Container } from 'react-bootstrap'
import { NRLogo } from '../assets/images'
import QRCode from "react-qr-code";
import { redirectPage, companyDetails } from '../hooks/auth'

const mapStateToProps = (state) => {
  return {
    auth: state.auth
  }
}


const mapDispatchToProps = dispatch => ({
  redirectPage: () => dispatch(redirectPage()),
  companyDetails: (token) => dispatch(companyDetails(token))
});

class Home extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      companyDetails: false
    };
    this.props.redirectPage()
  }

  componentDidUpdate() {
    if (this.props.auth.company == null && !this.state.companyDetails) {
      const path = window.location.pathname;
      const pathParts = path.split('/');
      const token = pathParts[1];
      this.props.companyDetails(token)
      this.setState({ companyDetails: true },()=>{  
          clearTimeout(this.timer)
          this.timer = setTimeout(() => {
            this.setState({companyDetails: false })
          }, 10000)
      })
    }
  }

  render() {
    return <Fragment>
      <NavbarComp />
      <div className="page-sections">
        <div className='home-wrap'>
          <Container>
            <div className='home-contents'>
              <h2 className='main-title-style'>WELCOME</h2>
              <p>To the <span>MyAlertness App in cooperation with {this.props.auth.company !== null ? this.props.auth.company.name : ""}.</span></p>
              {this.props.auth.company !== null ? <img src={this.props.auth.company.logo} ></img> : null}
              <p>If this is your first time on this page, please click the <a className='blue-link' href="" rel="nofollow">“REGISTER”</a> button or use the QR code. If you have already registered and would like to input data, please click the <a className='pink-link' href="" rel="nofollow">“LOGIN”</a> button or use the QR code.</p>
              <p>At the beginning of each shift, undertake the MyAlertness test and we will show you your CAS (Cognitive Accuracy Score) and how it compares that day to your baseline score.</p>
              <div className='register-login-buttons'>
                <a className='register-button' href={`${window.location.pathname}/register`} rel="nofollow"> REGISTER
                  <div className="div-qr">
                    <QRCode
                      size={256}
                      fgColor="#3DB6CD"
                      style={{ height: "130px", marginTop: "20px", width: "130px" }}
                      value={window.location.href + "register"}
                      viewBox={`0 0 256 256`}
                    />
                  </div>
                </a>
                <a className='login-button' href={`${window.location.pathname}/login`} rel="nofollow"> Login
                  <div className="div-qr">
                    <QRCode
                      size={256}
                      fgColor="#632467"
                      style={{ height: "130px", marginTop: "20px", width: "130px" }}
                      value={window.location.href + "login"}
                      viewBox={`0 0 256 256`}
                    />
                  </div>
                </a>
              </div>
            </div>
          </Container>
        </div>
      </div>

      <FooterComp />

    </Fragment>
  }
}

Home.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
